export default "__VITE_ASSET__BJA9udnW__"